import { types } from '../types';
import { createAction, createReducer } from '@reduxjs/toolkit';

const allDeviceList = createAction(types.DEVICE_LIST_SUCCESS);
const allCMDeviceList = createAction(types.DEVICE_CM_LIST_SUCCESS);
const currentDevice = createAction(types.Current_Device);
const getDeviceBreadcrumbList = createAction(types.SETDEVICE_BREADCRUMB_LIST);
const tagReferenceList = createAction(types.GET_TAGREFERENCE_LIST);
const initialState = {
  allDeviceList: [],
  allCMDeviceList: [],
  currentDevice: {},
  getDeviceBreadcrumbList: [],
  tagReferenceList: []
};

const DeviceReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(allDeviceList, (state, action) => {
      state.allDeviceList = action.deviceList;
    })
    .addCase(allCMDeviceList, (state, action) => {
      state.allCMDeviceList = action.deviceList;
    })
    .addCase(currentDevice, (state, action) => {
      state.currentDevice = action.device;
    })
    .addCase(getDeviceBreadcrumbList, (state, action) => {
      state.getDeviceBreadcrumbList = action.breadCrumbList;
    })
    .addCase(tagReferenceList, (state, action) => {
      state.tagReferenceList = action.response;
    })
    .addDefaultCase(() => { });
});

export default DeviceReducer;
